/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';

import Pliad from './Plaid';
import DwollaSignUpForm from '../../Profile/SubmitKYC/Form';
import {
	toastWhenDocumentIsSubmitted,
	toastWhenDocumentIsRejected,
	toastWaitForFurtherStep,
	toastKbaInitaitedPleaseRetuenAfterSomethime
} from '../../../SweetAlertUtil/util';
import { getReasonsOfFailure } from '../../../AppUtil/AppUtil';
import Loader from '../../Common/Loader';
import UserService from '../../../Service/UserService';
import { hot } from 'react-hot-loader';
class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isMainLoading: true
		};
	}

	checkDocumentUploadedStatus = () => {
		const currentUser = this.props.currentUser.profile;
		if (currentUser.account.documents.length !== 0 && currentUser.account.documents[0].status === 'pending') {
			return 'pending';
		} else {
			return '';
		}
	};

	getReasonsOfFailure = () => {
		return getReasonsOfFailure(this.props.currentUser.profile.account.documents[0].all_failure_reason);
	};

	checkDwollaStatus = () => {
		const currentUser = this.props.currentUser.profile;
		if (currentUser.account !== null) {
			if (currentUser.account.verification_status === 'document') {
				return this.checkDocumentUploadedStatus();
			} else if (
				currentUser.account.verification_status === 'suspended' &&
				currentUser.account.documents[0].failure_reason !== null
			) {
				return 'reviewed_with_failure';
			}
		}
	};

	toastWhenDocumentIsSubmitted = async () => {
		toastWhenDocumentIsSubmitted(this.props.openScreen);
		await this.props.onBack();
	};

	toastWhenDocumentIsRejected = async () => {
		toastWhenDocumentIsRejected(this.getReasonsOfFailure());
		await this.props.onBack();
	};

	toastWaitForFurtherStep = async () => {
		toastWaitForFurtherStep();
		await this.props.onBack();
	};

	toastKbaInitaitedPleaseRetuenAfterSomethime = async () => {
		toastKbaInitaitedPleaseRetuenAfterSomethime();
		await this.props.onBack();
	};

	updateProfile = async () => {
		const currentUser = await UserService.updateCurrentUser();

		if (currentUser.profile) {
			await this.props.setCurrentUser(currentUser);
			await this.setState({
				_isMainLoading: false
			});
		}
	};

	listenToEvent = e => {
		e.returnValue = '';
	};

	componentDidMount() {
		this.updateProfile();
		window.addEventListener('beforeunload', this.listenToEvent);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.listenToEvent);
	}

	render() {
		if (this.state._isMainLoading) {
			return <Loader />;
		}
		const account = this.props.currentUser.profile.account || {};
		if (!account.customer_id || account.verification_status !== 'verified') {
			const isNoneStepRequired = account.verification && account.verification.stepRequired === 'none';
			if (this.checkDwollaStatus() === 'pending') {
				this.toastWhenDocumentIsSubmitted();
				return null;
			} else if (this.checkDwollaStatus() === 'reviewed_with_failure') {
				this.toastWhenDocumentIsRejected();
				return null;
			} else if (isNoneStepRequired) {
				this.toastWaitForFurtherStep();
				return null;
			} else {
				return (
					<DwollaSignUpForm
						forKYC={false}
						currentUser={this.props.currentUser}
						onBack={this.props.onBack}
						openScreen={this.props.openScreen}
						setCurrentUser={this.props.setCurrentUser}
						supportedStates={this.props.supportedStates}
						typeOfUser={this.props.typeOfUser}
					/>
				);
			}
		} else if (!account.funding_source_id || account.plaid_status === 'ITEM_LOGIN_REQUIRED') {
			return (
				<Pliad
					onClose={this.props.onClose}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
				/>
			);
		} else {
			return null;
		}
	}
}

export default hot(module)(index);
